// assets\resources\js\core\bootstrap.js

import Carousel from 'bootstrap/js/dist/carousel';
import Tooltip from 'bootstrap/js/dist/tooltip';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Collapse from 'bootstrap/js/dist/collapse';
import Modal from 'bootstrap/js/dist/modal';
import Tab from 'bootstrap/js/dist/tab';
import Button from 'bootstrap/js/dist/button';


let inited = false;

export function initBootstrap() {
    if (inited) return;
    window.bootstrap = {Modal, Carousel, Tooltip, Dropdown, Collapse, Tab, Button};
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
        .forEach(el => new Tooltip(el));

    inited = true;
}
